export default [
  { value: 'booking_factory', label: 'Booking Factory' },
  { value: 'godo_property', label: 'Godo Property' },
  { value: 'cenium', label: 'Cenium' },
  { value: 'infor', label: 'Infor' },
  { value: 'beds_24', label: 'Beds 24' },
];
